import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Box, Typography } from '@material-ui/core';
const useStyles = makeStyles(() => ({
  root: {
    // backgroundColor: 'white',
    maxHeight: '90%',
  },
  image: {
    // maxWidth: "455px",
    width: '100%',
    marginBottom: '-48px',
    // marginTop:'-24px'
  },
}));

export const DisplayTemplate = ({ image, title, subtitle }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="xs">
          <Box textAlign="center">
            <img
              alt="Under development"
              className={classes.image}
              src={image}
            />
          </Box>
          <Typography align="center" color="textPrimary" variant="h4">
            {title}
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            {subtitle}
          </Typography>
        </Container>
      </Box>
    </div>
  );
};
